import * as React from 'react'
import { FC } from 'react'

import { PaymentMethod } from '@user/store/payments/typings'
import { Row } from './Row'
import { selectAllPayments } from '@user/store/payments/slice'
import { useSelector } from 'react-redux'

import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

const styles = {
  action: {
    color: '#007bff',
    cursor: 'pointer',
  },

  placeholderImg: {
    width: '200px',
    height: 'auto',
  },
}

interface Props {
  handleAddPayment: () => void
}

export const PaymentMethodsTable: FC<Props> = (props: Props) => {
  const { handleAddPayment } = props
  const paymentMethods = useSelector(selectAllPayments)

  return (
    <>
      {!paymentMethods.length && (
        <Box p={2}>
          <Paper>
            <Box
              display="flex"
              alignItems="center"
              flexDirection="column"
              p={2}
            >
              <Box>
                <img
                  alt="No payment methods captured"
                  style={styles.placeholderImg}
                  src="static-assets/icons/payment-method-placeholder.svg"
                />
              </Box>
              <Box pt={2}>
                <Typography display="inline">
                  No payment methods captured.{' '}
                </Typography>
                <Typography
                  sx={styles.action}
                  display="inline"
                  onClick={() => handleAddPayment()}
                >
                  Click here to add one.
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Box>
      )}
      {paymentMethods.length > 0 && (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Name</b>
              </TableCell>
              <TableCell>
                <b>Account Type</b>
              </TableCell>
              <TableCell>
                <b>Account No.</b>
              </TableCell>
              <TableCell>
                <b>Expiration</b>
              </TableCell>
              <TableCell>
                <b>Primary</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentMethods.map((method: PaymentMethod) => (
              <Row paymentMethod={method} key={method.id} />
            ))}
          </TableBody>
        </Table>
      )}
    </>
  )
}

PaymentMethodsTable.displayName = 'PaymentMethodsTable'
